import { useEffect } from 'react'
import { usePostProcessingStore } from '../stores/usePostProcessingStore'

const WINDOW_SIZE = 60
const UPDATE_INTERVAL = 500 // ms

export function useFpsMonitor() {
  useEffect(() => {
    const timestamps: number[] = []
    let lastUpdateTime = 0
    let rafId: number

    const tick = (now: number) => {
      timestamps.push(now)
      if (timestamps.length > WINDOW_SIZE) {
        timestamps.shift()
      }

      if (now - lastUpdateTime >= UPDATE_INTERVAL && timestamps.length >= 2) {
        lastUpdateTime = now
        const elapsed = timestamps[timestamps.length - 1] - timestamps[0]
        const fps = Math.round(((timestamps.length - 1) / elapsed) * 1000)

        usePostProcessingStore.getState().setCurrentFps(fps)
      }

      rafId = requestAnimationFrame(tick)
    }

    rafId = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(rafId)
  }, [])
}
